import getIllustration, {
  illustrationOptions as illustrationOptionsArray,
} from "./Illustrations";
export const illustrationOptions = illustrationOptionsArray;
export default getIllustration;
